<template>
    <span v-if="clock" :class="className">{{ clock }}</span>
    <span v-else :class="className">{{ $t('common.na') }}</span>
</template>

<script type="text/babel">
import { mapState, mapMutations } from 'vuex';
import { resourceMariTime } from '../../api/resources';
import format from 'date-fns/format';
import { getFullDateFormatNoSeconds } from '../common/helpers';
const SECOND = 1000;
const MINUTE = 60 * SECOND;
// Ensure that the clock can be wrong not more than CLOCK_UPDATE_TIMEOUT (after minimizing or unfocusing
// browser, or after switching to another browser tab and returning back, during which time setInterval
// can slow down and not update the clock in time).
const CLOCK_UPDATE_TIMEOUT = 20 * SECOND;

export default {
    name: 'MariTimeClock',

    props: {
        className: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            delta: null,
            clock: null,
            stopUpdating: false,
        };
    },

    computed: {
        ...mapState({
            mariCurrentTime: state => state.mariCurrentTime,
        }),
    },

    created() {
        this.updateMariTime().then(delay => this.updateClock(delay));
    },

    mounted() {
        this.clock = format(this.mariCurrentTime, getFullDateFormatNoSeconds());
    },

    beforeDestroy() {
        this.stopUpdating = true;
    },

    methods: {
        ...mapMutations({
            setMariCurrentTime: 'SET_MARI_CURRENT_TIME',
        }),

        updateClock(delayNext = CLOCK_UPDATE_TIMEOUT) {
            if (this.delta) {
                this.clock = format(
                    new Date(new Date().getTime() + this.delta),
                    getFullDateFormatNoSeconds()
                );
                this.setMariCurrentTime(new Date(new Date().getTime() + this.delta).getTime());
            } else {
                this.clock = null;
                this.setMariCurrentTime(null);
            }

            if (!this.stopUpdating) {
                setTimeout(() => this.updateClock(), delayNext);
            }
        },

        updateMariTime() {
            return resourceMariTime().then(res => {
                // Browser time
                let timestamp0 = new Date().getTime();
                // MARi time
                let timestamp1 = new Date((res && res.data) || null).getTime();
                // Difference between browser and MARi time
                this.delta = timestamp1 - timestamp0;
                // How many seconds are left until the next minute start (by MARi time)
                return MINUTE - (timestamp1 % MINUTE);
            });
        },
    },
};
</script>
